import { LoginFlowsWrapper } from './LoginFlowsWrapper';

export default LoginFlowsWrapper;
